<template>
  <div>
    <b-card v-if="products.length == 0">
      <div
        class="custom-card-title my-1 pb-1 text-left d-flex justify-content-between"
      >
        <b-skeleton width="30%" height="20%"></b-skeleton>
        <b-skeleton width="20%" height="20%"></b-skeleton>
      </div>
      <b-row class="mt-3">
        <b-col cols="4" md="2" v-for="item in 6" :key="item">
          <b-card no-body class="text-center border-0 custom-shop-item">
            <b-skeleton-img class="rounded-lg image contain"></b-skeleton-img>
            <b-card-body class="mt-3 d-flex justify-content-center">
              <b-skeleton
                width="40%"
                height="10%"
                class="align-center"
              ></b-skeleton>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      v-else
      no-body
      class="custom-card border-0 shadow-sm py-2 pb-3 px-4 flex-grow-1 h-100"
    >
      <div
        class="custom-card-title my-1 pb-1 text-left d-flex justify-content-between"
      >
        <p class="font-weight-bolder">
          <b-icon-shop class="text-primary"></b-icon-shop>&nbsp;
          {{ $t('home_ourProductLabel') }}
        </p>
        <b-link @click="$router.push('/products')" class="text-primary"
          >View Detail <b-icon-chevron-right></b-icon-chevron-right
        ></b-link>
      </div>

      <b-row class="d-flex flex-wrap">
        <b-col
          cols="12"
          md="2"
          v-for="(product, index) in limitedProducts"
          :key="`promo-${index}`"
          class="product-col"
        >
          <product-item :product="product"></product-item>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BIconChevronRight,
  BSkeleton,
  BSkeletonImg,
  BCardBody,
  BIconShop,
  BLink,
} from 'bootstrap-vue';
import productService from '../../services/product.service';
import productItem from '../productItem.vue';
export default {
  components: {
    BCard,
    BIconChevronRight,
    BSkeleton,
    BSkeletonImg,
    BCardBody,
    BIconShop,
    productItem,
    BLink,
  },
  data: () => ({
    placeholder: require('../../assets/images/yoma-placeholder.png'),
    shops: [],
    products: [],
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    limitedProducts() {
      return this.products.slice(0, 6);
    },
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    async getProducts() {
      try {
        const res = await productService.getProducts({status: "ACTIVE"});
        this.products = res.data.productList;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style>
.product-col {
  flex: 0 0 16.6667%;
  max-width: 16.6667%;
}
</style>
